import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dropdown-button',
  templateUrl: './dropdown-button.component.html',
  styleUrls: ['./dropdown-button.component.scss']
})
export class DropdownButtonComponent implements OnInit {

  @Input()
  btnTextKey: string;

  @Input()
  btnImageUrl: string;

  @Input()
  btnClasses = 'btn-primary';

  @Input()
  btnIconClass: string;

  @Input()
  alignLeft = false;

  @Input()
  large = true;

  @Input()
  small = false;

  @Input()
  smallPadding = false;

  @Input()
  closeOnClick = false;

  @Input()
  disabled = false;

  isOpen = false;

  constructor() {
  }

  ngOnInit() {
  }

  open() {
    this.isOpen = !this.isOpen;
  }

  close() {
    if (this.closeOnClick) {
      this.isOpen = false;
    }
  }

}
